import React, { useState } from 'react';
import PropTypes from 'prop-types';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';
import classnames from 'classnames';
import { DEFAULT_COUNTRY_INFO } from 'constants/options';

const PhoneNumberInput = ({
  labelText,
  placeholder,
  error,
  id,
  name,
  initialValue,
  setFieldValue,
  setFieldTouched,
  countryCode,
  countryField,
}) => {
  const [isFocus, setIsFocus] = useState(false);
  const isError = error !== '';

  const onFocusHandler = () => {
    setFieldTouched(name, false);
    setIsFocus(true);
  };

  const onValueChange = phoneNumber => {
    const phoneNumberValue = phoneNumber ? phoneNumber : '';
    setFieldValue(name, phoneNumberValue);
  };

  const onBlurHandle = () => {
    setIsFocus(!isFocus);
    setFieldTouched(name, true);
  };

  const onCountryChangeHandler = countryCode => {
    setFieldValue(countryField, countryCode);
    setFieldTouched(name, false);
  };

  return (
    <div className="lf-input-wrap">
      <label htmlFor={id} className="lf-input__label">
        {labelText}
      </label>
      <div onFocus={onFocusHandler} onBlur={onBlurHandle}>
        <PhoneInput
          id={id}
          name={name}
          placeholder={placeholder}
          defaultCountry={countryCode || DEFAULT_COUNTRY_INFO.countryCode}
          international
          value={initialValue}
          onChange={onValueChange}
          className={classnames(
            'lf-phone-number',
            { [`lf-phone-number--focus`]: isFocus },
            { [`lf-phone-number--error`]: isError }
          )}
          onCountryChange={onCountryChangeHandler}
        />
      </div>

      {isError && <p className="lf-input__helper">{error}</p>}
    </div>
  );
};

PhoneNumberInput.propTypes = {
  labelText: PropTypes.string,
  placeholder: PropTypes.string,
  error: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  initialValue: PropTypes.any,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  setFieldTouched: PropTypes.func,
  setFieldValue: PropTypes.func,
  countryCode: PropTypes.string,
  countryField: PropTypes.string,
};

PhoneNumberInput.defaultProps = {
  labelText: '',
  placeholder: '',
  error: '',
  id: '',
  name: '',
  initialValue: '',
  onBlur: () => {},
  setFieldTouched: () => {},
  setFieldValue: () => {},
};

export default PhoneNumberInput;
